// Step 25 — cross-domain connections.
//
// Renders ONLY explicit ID-backed relationships from
// `commandConnections` (which reuses Step 24 `executionConnections`).
// Backed by: ContractDraft.deal_action_id,
// ContractDraft.acquirer_id, DealAction.acquirer_id, and
// preparedness_observations.raised_by_acquirer_ids. No text matching.

import { Link } from "react-router-dom";

import { AIEmpty, AISection } from "../AIPrimitives";
import { commandConnections } from "./helpers";

const RELATION_LABEL = {
  contract_scoped_to_action: "Avtal ↔ Åtgärd",
  contract_scoped_to_buyer: "Avtal ↔ Köpare",
  action_scoped_to_buyer: "Åtgärd ↔ Köpare",
  preparedness_raised_by_buyer: "Beredskapsgap ↔ Köpare",
};

function _href(target, workspaceId) {
  if (target.type === "buyer" && target.id != null) {
    return `/deals/${workspaceId}/buyers/${target.id}`;
  }
  if (target.type === "contract" && target.id != null) {
    return `/deals/${workspaceId}/contracts/${target.id}`;
  }
  if (target.type === "action") {
    return `/deals/${workspaceId}/actions`;
  }
  return null;
}

export default function AICommandConnections({
  actions,
  contracts,
  situation,
  workspaceId,
}) {
  const conns = commandConnections({ actions, contracts, situation });
  if (conns.length === 0) {
    return (
      <AISection title="Kopplingar mellan domäner">
        <AIEmpty
          title="Inga explicita kopplingar registrerade"
          hint={
            "Kopplingar visas endast när det finns faktiska ID-relationer " +
            "(t.ex. ContractDraft.deal_action_id, DealAction.acquirer_id). " +
            "Textlikhet räknas inte."
          }
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Kopplingar mellan domäner"
      right={
        <span className="qai-page-section-hint">
          {conns.length} koppling{conns.length === 1 ? "" : "ar"} · endast via IDs
        </span>
      }
    >
      <ul className="qai-command-connections">
        {conns.map((c) => {
          const fromHref = _href(c.from, workspaceId);
          const toHref = _href(c.to, workspaceId);
          return (
            <li key={c.key} className="qai-command-connection-row">
              <span className="qai-command-connection-relation">
                {RELATION_LABEL[c.relation] || c.relation}
              </span>
              <span className="qai-command-connection-endpoint">
                {fromHref ? (
                  <Link to={fromHref} className="qai-page-section-link">
                    {c.from.label}
                  </Link>
                ) : (
                  c.from.label
                )}
              </span>
              <span className="qai-command-connection-arrow">→</span>
              <span className="qai-command-connection-endpoint">
                {toHref ? (
                  <Link to={toHref} className="qai-page-section-link">
                    {c.to.label}
                  </Link>
                ) : (
                  c.to.label
                )}
              </span>
            </li>
          );
        })}
      </ul>
    </AISection>
  );
}
